import * as React from 'react';
import { Button, CommandButton, DefaultButton, IconButton, SearchBox } from "@fluentui/react";
import { color } from "d3";
import { IButtonGroupTable } from '../../interfaces/base/ITable';
import { IconStyle } from '../../functions/IconStyle';
import { ComboBoxComponent } from '../../components/comboBoxComponent/ComboBoxComponent';

export const ButtonGroupTable = (props: IButtonGroupTable) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "end",
        borderBottom: "0.5px solid #b3b3b3",
        boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div key={"leftBotton"}>
        <div style={{ display: "flex" }}>
          {props.leftButtons?.map((button, index) => (
            <CommandButton
              split
              key={index}
              onClick={button.onClick}
              style={{
                fontSize: "12px",
                fontWeight: "normal",
                display: button.text === "" ? "none" : "flex",
                backgroundColor: button.background == null ? 'none' : button.background,
                color: button.color == null ? 'none' : button.color,
                border: 3
              }}
              disabled={button.disable == null ? false : button.disable}
              //appearance={button.type == undefined ? "subtle" : button.type}
              iconProps={{ iconName: IconStyle(button.text) }}
            >
              {button.text}

            </CommandButton>
          ))}
        </div>
      </div>
      <div key={"rightBotton"}>
        <div
          style={{
            display: "flex",
            gap: "4px",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          {props.comboOptions ? (
            <ComboBoxComponent
              text=""
              defaultSelectedOptions={props.defaultSelectedOptions ?? []}
              data={props.comboOptions}
              onOptionSelect={props.onSelectCombo}
            />
          ) : (
            true
          )}
          {props.isSearch && (
            <SearchBox
              value={props?.value}
              style={{ width: "200px", height: "32px", marginBottom: "2px" }}
              placeholder={props.placeholder ?? ""}
              onChange={props.onChangeSearch}
            />
          )}
          {props.rightButton?.map((button, index) => (
            <DefaultButton
              key={index}
              onClick={button.onClick}
              style={{
                fontSize: "12px",
                fontWeight: "normal",
                display: button.text === "" ? "none" : "flex",
                backgroundColor: button.background == null ? 'none' : button.background,
                color: button.color == null ? 'none' : button.color,
                border: 3
              }}
              //appearance={button.type == undefined ? "subtle" : button.type}
              iconProps={{ iconName: IconStyle(button.text) }}
              disabled={button.disabled}


            >
              {button.text}
            </DefaultButton>
          ))}
          {props.rightText ? <span>{props.rightText}</span> : true}

        </div>
      </div>
    </div>
  )
}